import React, { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../../componentes/Comunes/PageHeading";
import ParametrosPadron from "../../../componentes/Padron/ComponenteConsultaPadron/ParametrosPadron";

class ConsultaPadron extends Component {
  render() {
    return (
      <Layout>
        <div>
          {/* <!-- Page Heading --> */}
          <PageHeading title="Consulta al Padrón" />
          <ParametrosPadron />
        </div>
      </Layout>
    );
  }
}

export default ConsultaPadron;
